import Button from '../../Button';
import IntroComponent from '../components/intro.components';
import ArrowUpDarkGreen from '../../../assets/arrow-up-dark-green-icon.svg';
import ArrowUpLightGreen from '../../../assets/arrow-up-light-green-icon.svg';
import HelpIcon from '../../../assets/help-green-icon.svg';
import { ArticleTableComponent } from '../components/article-table.component';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@chakra-ui/react';
import { EARNING_TEXT } from '../../../constants/twygs.constant';
import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchListMyArticles, getTotalArticleEarnings } from '../../../apis/article.api';
import { formartNumber } from '../../../utils/helper.util';
import { useEffect, useState } from 'react';

const ArticlesComponent = () => {
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const navigate = useNavigate();
  const params = {
    limit: 1,
    page: 1,
    status: 'draft'
  };

  const { data: getRecentArticle } = useQuery({
    queryKey: ['recent-article'],
    queryFn: () => fetchListMyArticles(params)
  });

  const { mutateAsync: getTotalArticleEarningsAsync } = useMutation({
    mutationFn: getTotalArticleEarnings
  });

  const handleContinueWriting = () => {
    navigate(`/article/edit?id=${getRecentArticle?.data[0]?.id}&step=4`);
  };

  useEffect(() => {
    (async () => {
      const response = await getTotalArticleEarningsAsync();
      setTotalEarnings(response?.earnings || 0);
    })();
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <IntroComponent
        title="My Articles"
        des="Manage, edit, and share your articles for engaging online presence"
      />
      <div className="px-4 md:px-0 flex items-center gap-5 flex-col md:flex-row">
        <div className="bg-white p-6 rounded-[12px] border border-05-seasalt-white shadow-[0px_4px_4px_0px_#F2F3F780] w-full md:w-fit">
          <p className="text-growth-green-900 text-sm">Recently worked on</p>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:gap-8 mt-2">
            <p
              className="font-[800] text-sm max-w-[182px] truncate"
              title={getRecentArticle?.data[0]?.title}
            >
              {getRecentArticle?.data?.length > 0
                ? getRecentArticle?.data[0]?.title || 'Untitled'
                : 'No article yet'}
            </p>
            <Button
              variant="secondary"
              onClick={handleContinueWriting}
              disabled={getRecentArticle?.data?.length === 0}
              className="whitespace-nowrap"
            >
              Continue writing
              <img
                className={`ml-2 ${getRecentArticle?.data?.length === 0 ? 'opacity-30' : ''}`}
                src={ArrowUpDarkGreen}
                alt=""
              />
            </Button>
          </div>
        </div>
        <div className="bg-white p-6 rounded-[12px] border border-05-seasalt-white shadow-[0px_4px_4px_0px_#F2F3F780] w-full md:w-fit">
          <div className="flex items-center gap-2">
            <p className="font-[800] text-sm">Earnings</p>
            <Tooltip
              rounded={'0.75rem'}
              label={EARNING_TEXT?.map((item, index) => (
                <p key={index} className="text-[10px]">
                  {item}
                </p>
              ))}
              placement={'top-start'}
              bg={'anti-flash-white'}
              p={{ base: '10px', md: '1rem' }}
              color={'jet-black'}
              fontSize={'10px'}
              maxW={'321px'}
              isOpen={isTooltipOpen}
            >
              <img
                src={HelpIcon}
                alt=""
                onMouseEnter={() => setIsTooltipOpen(true)}
                onMouseLeave={() => setIsTooltipOpen(false)}
                onClick={() => setIsTooltipOpen((prev) => !prev)}
              />
            </Tooltip>
          </div>
          <div className="flex items-center gap-4 mt-2">
            <p className="text-growth-green-900 text-[24px] font-[800]">
              ${formartNumber(totalEarnings, 2)}
            </p>
            <a
              className="flex gap-2 items-center hover:opacity-80 cursor-pointer"
              href="/creator-dashboard/earnings/my-earnings"
            >
              <p className="text-growth-green-500 text-sm font-[900]">For more details</p>
              <img className="fill-growth-green-500" src={ArrowUpLightGreen} alt="" />
            </a>
          </div>
        </div>
      </div>
      <ArticleTableComponent />
    </div>
  );
};

export default ArticlesComponent;
